import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },

  flag: {
    marginRight: '8px'
  },

  extraChannelsLabel: {},

  extraChannelsResults: {
    marginTop: 10
  },

  dropdown: {
    marginLeft: 6,
    cursor: 'pointer',
    width: theme.size.sm
  },

  resultsContainer: {
    border: '1px solid #F0F0F0',
    borderRadius: '7px',
    boxSizing: 'border-box',
    boxShadow: '0px 20px 30px rgba(0, 0, 0, 0.16)',
    padding: '16px',
    background: 'white',

    '& > ul': {
      padding: '0'
    }
  },

  result: {
    borderRadius: '8px',
    height: '48px',
    padding: '0 12px',
    fontSize: theme.size.base,

    '&:hover': {
      background: '#F5F6F8'
    }
  },

  smsResult: {
    cursor: 'inherit',
    color: '#3C425B'
  },

  smsValue: {
    color: 'grey',
    fontSize: theme.size.sm,
    cursor: 'inherit',
    marginLeft: '8px'
  },

  flagDropdown: {
    marginLeft: '8px'
  }
}))

export default useStyles
